import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { NetworkStatus } from '@cbridge-utils/network';
import { PriceFilteringAction } from './priceFiltering.action';
import { priceFilteringInitialState } from './priceFiltering.constant';
import { IPriceFilteringStore } from './priceFiltering.interface';

export const priceFilteringReducer = reducerWithInitialState(priceFilteringInitialState)
  .case(PriceFilteringAction.loadList.started, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Started,
  }))
  .case(PriceFilteringAction.loadList.done, (state, { result }): IPriceFilteringStore => {
    const data = {};
    Object.values(result.data).forEach((item) => {
      data[item.priceFilteringId] = item;
    });

    return {
      ...state,
      data,
      defaultData: result.defaultData,
      networkStatus: NetworkStatus.Done,
    };
  })
  .case(PriceFilteringAction.loadList.failed, (state) => ({
    ...state,
    networkStatus: NetworkStatus.Failed,
  }))
  .case(PriceFilteringAction.remove.done, (state, payload): IPriceFilteringStore => {
    const { data, defaultData } = state;
    const { params: { priceFilteringId } } = payload;

    delete data[priceFilteringId];

    return {
      ...state,
      data: {
        ...data,
      },
      defaultData,
    };
  })
  .case(PriceFilteringAction.destroy, () => ({
    ...priceFilteringInitialState,
  }));
